import styled from 'styled-components';

import {Device} from '../../../constants';

import FlexContainer from './FlexContainer';

const StyledHeroFlexContainer = styled(FlexContainer)<{bkImg?: string | null}>`
  ${(props) =>
    props.bkImg
      ? `
                background-image: url(${props.bkImg});
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                margin-top: -250px;
                padding-top: 150px;
                clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 10%);

                @media only screen and ${Device.mobileL} {
                  clip-path: polygon(0% 0%, 0% 95%, 100% 100%, 100% 5%);
                }
            `
      : null}

  @media and (min-width: 2560px) {
    margin-top: -180px;
  }

  @media screen and ${Device.mobileL} {
    margin-top: -180px;
  }
`;

export default StyledHeroFlexContainer;
